<template>
<span v-html="meetLogo"></span>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'MeetLogo',
    computed: {
        ...mapState({
            t: state => state.t.newsfeed
        }),
        meetLogo() {
            return this.t.quickie.replace('Quickie', '<img class="meet-logo" src="/assets/images/quickie.svg">');
        }
    }
};

</script>
